import { FC, useEffect, useState } from 'react'
import { Box, SxProps, Theme } from '@mui/material'
import { LIGHT_COLORS_VARIANTS_OPACITY } from '@/utils/constants/colors'
import { FilterElement, FilterElementProps } from './FilterElement'

export interface FilteringModuleProps {
  elements: Omit<FilterElementProps, 'onClick' | 'activeId'>[]
  onFilterChange?: (id: string | number) => void
  initialActiveId?: string | number | null
  sx?: SxProps<Theme>
}

export const FilteringModule: FC<FilteringModuleProps> = ({
  elements,
  sx,
  onFilterChange,
  initialActiveId,
}) => {
  const [activeElementId, setActiveElementId] = useState<string | number>(initialActiveId ?? 1)

  useEffect(() => {
    setActiveElementId(initialActiveId ?? 1)
  }, [initialActiveId])

  const handleElementClick = (id: string | number) => {
    setActiveElementId(id)
    onFilterChange?.(id)
  }

  return (
    <Box
      display="flex"
      width="100%"
      gap={1}
      justifyContent="center"
      alignItems="center"
      sx={{
        backdropFilter: 'blur(4px)',
        bgcolor: LIGHT_COLORS_VARIANTS_OPACITY[1050],
        borderRadius: '0.75rem',
        ...sx,
      }}
      p={1}
    >
      <Box
        display="flex"
        width="100%"
        gap={2}
        justifyContent="safe center"
        alignItems="center"
        sx={{
          flexShrink: 0,
          overflowX: 'auto',
        }}
      >
        {elements.map((element) => (
          <FilterElement
            key={element.id}
            {...element}
            onClick={handleElementClick}
            activeId={activeElementId}
          />
        ))}
      </Box>
    </Box>
  )
}
